"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripleSlashAbilityHandler = exports.TripleSlashActorAbilityFactory = exports.TripleSlashAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class TripleSlashAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TripleSlash;
        this.__typeName = "TripleSlash";
    }
}
exports.TripleSlashAbilityArgs = TripleSlashAbilityArgs;
let TripleSlashActorAbilityFactory = class TripleSlashActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TripleSlash", "AllEnemies", 1);
    }
};
TripleSlashActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TripleSlash")
], TripleSlashActorAbilityFactory);
exports.TripleSlashActorAbilityFactory = TripleSlashActorAbilityFactory;
let TripleSlashAbilityHandler = class TripleSlashAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
            .flatMap(targetId => [targetId, targetId, targetId]);
        const additionalEffects = Array.of();
        if (container.hasAttribute(ability.invokerId, "Charm_Gladiator_0")) {
            additionalEffects.push(new __1.BleedingEffectArgs("Power", 10));
        }
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            attackType: "melee",
            abilityKey: ability.args.__typeName,
            targets: targets.map((targetId) => ({
                jitter: 0,
                targetId,
                effects: [
                    ...additionalEffects.map(effect => ({
                        duration: __1.Duration.Turns(4),
                        effect,
                        targetId
                    }))
                ],
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 25)
                ],
            })),
            sequence,
        });
    }
};
TripleSlashAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TripleSlash)
], TripleSlashAbilityHandler);
exports.TripleSlashAbilityHandler = TripleSlashAbilityHandler;
